import { CLIENT_URL } from '@shared/config/api/api';

export const authLogout = async () => {
  await fetch(`${CLIENT_URL}/v2/auth/logout`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json;charset=utf-8'
    }
  });
};
